import React from "react";
import propTypes from "prop-types";
import { Link } from "react-router-dom";
export default function Navbar(props) {
  return (
    <div>
      <nav
        className={`navbar navbar-expand-lg navbar-${props.mode} bg-${props.mode}`}
      >
        <div className="container-fluid">
          <Link className="navbar-brand" to="/">
            {props.title}
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link className="nav-link active" aria-current="page" to="/">
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/About">
                  {props.aboutText}
                </Link>
              </li>
            </ul>
            <div
              className={`form-check form-switch mx-2 text-${
                props.mode === "light" ? "dark" : "light"
              }`}
            >
              <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                id="flexSwitchCheckDefault"
                onClick={() => props.toggleMode()}
              />
              <label
                className="form-check-label mx-2 text-{}"
                htmlFor="flexSwitchCheckDefault"
              >
                Darkmode
              </label>
            </div>

            {/* <div className={`form-check form-switch mx-2 text-${props.mode==='light'?'dark':'light'}`}>
              <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                id="flexSwitchCheckDefault"
                onClick={()=>props.toggleMode('danger')}
              />
              <label className="form-check-label mx-2 text-{}" htmlFor="flexSwitchCheckDefault">
                Redmode
              </label>
            </div>

            <div className={`form-check form-switch mx-2 text-${props.mode==='light'?'dark':'light'}`}>
              <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                id="flexSwitchCheckDefault"
                onClick={()=>props.toggleMode('success')}
              />
              <label className="form-check-label mx-2 text-{}" htmlFor="flexSwitchCheckDefault">
                Greenmode
              </label>
            </div> */}


            <form className="d-flex">
              <input
                className="form-control me-2"
                type="search"
                placeholder="Search"
                aria-label="Search"
              />
              <button className="btn btn-success" type="submit">
                Search
              </button>
            </form>
          </div>
        </div>
      </nav>
    </div>
  );
}

//isRequired is used to denote that the field is mandatory
Navbar.propTypes = {
  title: propTypes.string.isRequired,
  aboutText: propTypes.string.isRequired,
};

//to set default values for the props
Navbar.defaultProps = {
  title: "Set title here",
  aboutText: "About text here",
};
